import React from 'react';
import './modal.css';

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modalOverlay">
      <div className="modalContent">
        <button onClick={onClose} className="closeButton">
            X
        </button>
        <hr className='hr'/>
        {children}
        <hr/>
        <div className="bottomButtonContainer">
          <button onClick={onClose} className="bottomCloseButton">Sluit</button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
